import React from 'react';
import { Alert } from '@/components/ui';

const YellowHeaderInfo: React.FC = () => (
  <Alert variant="info" className="tw-flex tw-items-center tw-mb-3">
    <i className="bi bi-info-circle tw-mr-2"></i>
    <span>
      <strong>Note:</strong> Columns with yellow headers are informational only and will not be included in the exported report.
    </span>
  </Alert>
);

export default YellowHeaderInfo;